module.exports = __webpack_public_path__ + "img/1268802430.76b20b77.jpg";